import { render, staticRenderFns } from "./SmChip.vue?vue&type=template&id=fb2a66e2&scoped=true&"
import script from "./SmChip.vue?vue&type=script&lang=ts&"
export * from "./SmChip.vue?vue&type=script&lang=ts&"
import style0 from "./SmChip.vue?vue&type=style&index=0&id=fb2a66e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2a66e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
